import { Store } from "@tanstack/react-store";

export const cartStore = new Store({
  selectedItems: [] as string[],
});

export const updateSelectedItems = (lineItemId: string): void => {
  cartStore.setState((state) => {
    let newSelectedItems = [...state.selectedItems];
    if (newSelectedItems.indexOf(lineItemId) >= 0) {
      newSelectedItems = newSelectedItems.filter((item) => item !== lineItemId);
    } else {
      newSelectedItems.push(lineItemId);
    }

    return {
      ...cartStore,
      selectedItems: newSelectedItems,
    };
  });
};

export const selectAllItems = (lineItemIds: string[]): void => {
  cartStore.setState(() => {
    return {
      ...cartStore,
      selectedItems: lineItemIds,
    };
  });
};
